import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { useMyFolders } from '../context/MyFolders';

const MyFoldersHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useMyFolders();

  const ancestors = data.currentFolder?.ancestors || [];

  return (
    <div className="folder-breadcrumb">
      <span
        className="folder-breadcrumb__link"
        onClick={() => actions.handleNavigateToFolder()}
      >
        {t('MyFolders')}
      </span>

      {ancestors.map((ancestor) => (
        <span key={ancestor._id} className="folder-breadcrumb__item">
          <span className="folder-breadcrumb__separator">/ </span>
          <span
            className="folder-breadcrumb__link"
            onClick={() => actions.handleNavigateToFolder(ancestor._id)}
          >
            {ancestor.name}
          </span>
        </span>
      ))}

      <span className="folder-breadcrumb__separator">/</span>
      <span className="folder-breadcrumb__current">
        {data.currentFolder?.name}
      </span>
    </div>
  );
};

export default MyFoldersHeader;
